'use strict';
import simpleParallax from 'simple-parallax-js';
import * as dom from './lib/dom.js';

const calcImageZoom = (windowWidth) => {
    console.log('calcImageZoom');
    let imageContents = document.querySelectorAll('.js-company-image-content');
    console.log('teste');

    let zoomValue;
    let heightValue;
    if(windowWidth < 1023){ 
        console.log('< 1023');
        console.log((windowWidth / 320) + 'px');
        zoomValue = windowWidth / 320;
        heightValue = 318 * zoomValue + 'px'
    } else {
        console.log('> 1023');
        console.log((windowWidth / 1024) + 'px');
        zoomValue = windowWidth / 1024;
        heightValue = 740 * zoomValue + 'px';
    }

    dom.forEachEl(imageContents, (imageContent) => {
        imageContent.style.transform = 'scale('+zoomValue+')';
        // imageContent.style.zoom = zoomValue.toFixed(2).split('.').join("")+'%';
        imageContent.style.height = heightValue;
    });
    
}

const initCompany = () => {
    console.log('initCompany');
    const imagesParallaxUp = document.querySelectorAll('.js-parallax-up');
    const imagesParallaxDown = document.querySelectorAll('.js-parallax-down');

    const windowWidth = window.innerWidth;
    calcImageZoom(windowWidth);

    if(windowWidth < 1023){ 
        return
    }
    const isHome = document.querySelector('.home');
    const isPage = document.querySelector('.page-template-page-interna-podcasts');
    if (isHome || isPage) {
        if (imagesParallaxUp.length > 0) {
            dom.forEachEl(imagesParallaxUp, (image) => {
                new simpleParallax(image, {
                    orientation: 'up',
                    scale: 1.2,
                    transition: 'ease',
                });
            });
        }
        

        if (imagesParallaxDown.length > 0) {
            dom.forEachEl(imagesParallaxDown, (image) => {
                new simpleParallax(image, {
                    orientation: 'down',
                    scale: 1.2,
                    transition: 'ease',
                });
            });
        }
    }
}

export default function(){
    window.addEventListener('load', function() {
        const has_company = document.querySelector('.js-b9-company');
        if (!has_company) { return }
        initCompany();
        
    });

    window.addEventListener('turbolinks:load', function() {
        const has_company = document.querySelector('.js-b9-company');
        if (!has_company) { return }
        initCompany();
    });

    window.addEventListener('resize', function() {
        const has_company = document.querySelector('.js-b9-company');
        if (has_company) { return }
        const windowWidth = window.innerWidth;

        calcImageZoom(windowWidth);
    });
    
}
